import React from 'react';

import { ReactComponent as Confused } from '../assets/Confused.svg';
import { ReactComponent as DontFeelWell } from '../assets/DontFeelWell.svg';
import { ReactComponent as FloatIcons } from '../assets/FloatIcon.svg';
import { ReactComponent as Happy } from '../assets/Happy.svg';
import { ReactComponent as Org } from '../assets/Organization.svg';
import { ReactComponent as Question } from '../assets/Question.svg';
import { ReactComponent as Team } from '../assets/Team.svg';
import { ReactComponent as Tired } from '../assets/Tired.svg';
import { ReactComponent as Upset } from '../assets/Upset.svg';

type IconProviderProps = {
    acrn: string;
    iconHeight?: string;
};

const IconProvider = ({ acrn, iconHeight }: IconProviderProps) => {
    const getIcon = (iconName: string) => {
        switch (iconName) {
            case 'HAPPY':
                return <Happy style={{ height: iconHeight }} />;
            case 'QUESTION':
                return <Question style={{ height: iconHeight }} />;
            case 'CONFUSED':
                return <Confused style={{ height: iconHeight }} />;
            case 'TIRED':
                return <Tired style={{ height: iconHeight }} />;
            case 'DONTFEELWELL':
                return <DontFeelWell style={{ height: iconHeight }} />;
            case 'UPSET':
                return <Upset style={{ height: iconHeight }} />;
            case 'FLOATING':
                return <FloatIcons style={{ height: iconHeight }} />;
            case 'TEAM':
                return <Team style={{ height: iconHeight }} />;
            case 'ORGANIZATION':
                return <Org style={{ height: iconHeight }} />;
            default:
                return null;
        }
    };
    return <> {getIcon(acrn)} </>;
};

export default IconProvider;
